/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AppRouter } from '@gh/common-shared';
import { TranslationTuple } from '@gh/core-mls';
import { ID } from '@gh/common-shared-data';
import { Router } from '@angular/router';

export interface AelNavigationParams {
  label?: string | TranslationTuple;
  entityType?: string;
  entityId?: any;
  eventTypeIds?: number[];
  route?: string;
}

@Injectable()
export class BuilderNavigationService {
  constructor(private router: AppRouter,
              private angRouter: Router) {

  }

  goToAel(params?: AelNavigationParams): Promise<boolean> {
    let navigationParams = {};

    if (params) {
      navigationParams = {
        parentTitle: params.label,
        queryParams: {
          entityType: params.entityType,
          entityId: params.entityId,
          eventTypeIds: params.eventTypeIds && params.eventTypeIds.join(','),
        },
      };
    }

    return this.router.navigateToChild(['/ael'], navigationParams);
  }

  goToOfficeAel(officeId: ID, params?: AelNavigationParams): void {
    let navigationParams = {};

    if (params) {
      navigationParams = {
        parentTitle: params.label,
        queryParams: {
          entityType: params.entityType,
          entityId: params.entityId,
          eventTypeIds: params.eventTypeIds && params.eventTypeIds.join(','),
        },
      };
    }
    const url = this.angRouter.serializeUrl(
      this.angRouter.createUrlTree([`office-view/${officeId}/ael`], navigationParams));

    window.open(url, '_blank');
  }
}
